import SmxCard from "@shared/components/elements/SmxCard.vue";
import SmxFormItem from "@shared/components/elements/SmxFormItem.vue";
import SmxForm from "@shared/components/elements/SmxForm.vue";
import SmxFormSubtitle from "@shared/components/elements/SmxFormSubtitle.vue";

export const smxElements = {
  SmxForm: SmxForm,
  SmxFormItem: SmxFormItem,
  SmxFormSubtitle: SmxFormSubtitle,
  SmxCard: SmxCard,
};
